<template>
    <div>
        <div class="d-flex" :style="getStyle()">
            <span @click.stop="openCloseSelf()" class="mr-2">
                <b v-if="category.children.length === 0"> </b>
                <b v-else-if="is_open_child">-</b>
                <b v-else>+</b>
            </span>
            <label @click="selectSelf">{{props.category.name}}</label>
        </div>
        <div v-if="is_open_child" v-for="child in props.category.children">
        <custom-category-select-child
                :category="child"
                :depth="props.depth+1"
                :key="child_key"
                :selected_categories="props.selected_categories"
                @selectCategory="childWasSelected($event)"
            ></custom-category-select-child>
        </div>
    </div>
</template>




<script setup>
import {ref, watch, computed} from 'vue'

const props = defineProps({category: Object, depth: Number, selected_categories: Array})
const emit = defineEmits(['selectCategory'])

const is_open_child = ref(false)
const is_selected = ref(false)
const is_selected_computed = computed(() => { return updateSelected()})
const child_key = ref(0)

watch(() => props.selected_categories, (newVal) => {
    updateSelected()
    // is_selected.value = newVal.includes(props.category.id)
})

function updateSelected(){
    is_selected.value = getSelectedStatus()
    return is_selected.value
}

function getSelectedStatus(){
    let index = props.selected_categories.findIndex(cat => cat.id === props.category.id);
    console.log(index)
    return index !== -1
}

function openCloseSelf(){
    is_open_child.value = !is_open_child.value
}

function selectSelf(){
    emit('selectCategory',props.category)
    is_selected.value = !is_selected.value
    if(is_selected.value) {
        is_open_child.value = true
    }
    child_key.value++;
}

function childWasSelected(child){
    emit('selectCategory',child)
}

function getStyle(){
    const padding =  'padding-left:' + (2*props.depth) + 'rem; '
    const color = is_selected.value ? 'color:green !important;' : 'color:black;'
    return padding + color;
}
</script>







<style scoped>

</style>
